// extracted by mini-css-extract-plugin
export default {"bgBanner":"BgBanner_bgBanner__5NlwT","bgBanner__text":"BgBanner_bgBanner__text__YuNaj"};